const SaadiaAwan = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex grid  lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] text-[30px] font-bold">
              Saadia Awan
            </h1>
            <p>Company Director</p>
          </div>
          <div className="flex justify-end">
            <img
              src="/leadershipnew/saadia-awaan2.jpg"
              alt=""
              className="lg:h-[26rem] h-[17rem] leadership-images mx-[2rem] "
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="lg:text-[30px] md:text-[32px] sm:text-[32px] text-[26px] font-bold">
              Saadia Awan
            </h1>
            <p>Company Director</p>
          </div>
        </div>
      </div>
      <div className="max-w-[40rem] sm:mx-auto mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-left gap-4">
        <p>
          Mrs Saadia Awan is the wife of Mr. Khalid Awan and has been by his
          side throughout various stages of business and organisational
          developments. She played an active role in the early years, and as
          Company Director since 1992 is keenly focused on service quality and
          efficiencies within the organisation.
        </p>
        <p>
          She is an active social worker. As a founding member of The Citizens
          Foundation, Mrs Awan has been involved in establishing the TCF chapter
          in Canada in 2005. She serves as the Company Director and is certified
          by the Pakistan Institute of Corporate Governance.
        </p>
        {/* <p>
            She is an active social worker and has been involved with The Citizens Foundation since its founding, and 
            established its chapter in Canada in 2005.
          </p>
          <p>
            Mrs. Awan is Company Director and is certified by the Pakistan Institute of Corporate Governance.
          </p> */}
      </div>
    </div>
  );
};
export default SaadiaAwan;
